// Spanish translations
export const es = {
  brandName: "GateGroup Inc",
  login: "Iniciar Sesión",
  register: "Registrarse",
  logout: "Cerrar Sesión",
  dashboard: "Panel",
  settings: "Configuración",
  adminPanel: "Panel de Admin",
  search: "Buscar",
  viewAll: "Ver Todo",
  learnMore: "Saber Más",
  getStarted: "Comenzar",
  downloadApp: "Descargar App",
  
  nav: {
    trade: "Operar",
    markets: "Mercados",
    earn: "Ganar",
    learn: "Aprender",
    more: "Más",
    spotTrading: "Trading Spot",
    spotTradingDesc: "Compra y vende más de 2,000 criptomonedas",
    futures: "Futuros",
    futuresDesc: "Opera con hasta 125x de apalancamiento",
    marginTrading: "Trading con Margen",
    marginTradingDesc: "Amplifica tu poder de trading",
    copyTrading: "Copy Trading",
    copyTradingDesc: "Sigue a los mejores traders automáticamente",
    tradingBots: "Bots de Trading",
    tradingBotsDesc: "Automatiza tus estrategias 24/7",
    p2pTrading: "Trading P2P",
    p2pTradingDesc: "Opera directamente con otros",
    marketOverview: "Resumen del Mercado",
    marketOverviewDesc: "Todos los mercados y precios",
    cryptocurrencies: "Criptomonedas",
    cryptocurrenciesDesc: "BTC, ETH y más de 2000",
    newListings: "Nuevos Listados",
    newListingsDesc: "Últimas adiciones de tokens",
    topGainers: "Mayores Ganancias",
    topGainersDesc: "Mejores rendimientos hoy",
    simpleEarn: "Simple Earn",
    simpleEarnDesc: "Ahorros flexibles hasta 12% APY",
    staking: "Staking",
    stakingDesc: "Bloquea y gana recompensas",
    launchpool: "Launchpool",
    launchpoolDesc: "Cultiva nuevos tokens",
    hodlerAirdrops: "HODLer Airdrops",
    hodlerAirdropsDesc: "Recompensas para holders",
    cryptoAcademy: "Academia Crypto",
    cryptoAcademyDesc: "Cursos para todos los niveles",
    videoTutorials: "Video Tutoriales",
    videoTutorialsDesc: "Guías paso a paso",
    articlesGuides: "Artículos y Guías",
    articlesGuidesDesc: "Conocimiento profundo",
    helpCenter: "Centro de Ayuda",
    helpCenterDesc: "FAQs y soporte",
    aboutUs: "Sobre Nosotros",
    aboutUsDesc: "Nuestra historia y misión",
    security: "Seguridad",
    securityDesc: "Cómo te protegemos",
    proofOfReserves: "Prueba de Reservas",
    proofOfReservesDesc: "100% transparencia",
    careers: "Carreras",
    careersDesc: "Únete a nuestro equipo",
  },
  
  hero: {
    title1: "Tu Puerta de Entrada a las",
    title2: "Criptomonedas",
    subtitle: "Confianza de más de",
    traders: "49 millones",
    tradersText: "de traders en todo el mundo",
    continueWith: "O continúa con",
  },
  
  stats: {
    volume24h: "Volumen 24h",
    cryptocurrencies: "Criptomonedas",
    simpleEarnApy: "APY Simple Earn",
    reserveRatio: "Ratio de Reserva",
  },
  
  products: {
    title: "Opera en Cualquier Momento y Lugar",
    subtitle: "Productos diversos para todas las estrategias de trading",
    spotTrading: "Trading Spot",
    spotDesc: "Más de 2000 pares",
    futures: "Futuros",
    futuresDesc: "Hasta 125x apalancamiento",
    copyTrading: "Copy Trading",
    copyDesc: "Sigue a expertos",
    tradingBots: "Bots de Trading",
    botsDesc: "Automatizado 24/7",
    simpleEarn: "Simple Earn",
    earnDesc: "Rendimientos flexibles",
    launchpool: "Launchpool",
    launchDesc: "Nuevos tokens",
    popular: "Popular",
    hot: "Caliente",
    easy: "Fácil",
    smart: "Inteligente",
    earn: "Ganar",
    exclusive: "Exclusivo",
  },
  
  howToStart: {
    title: "Cómo Empezar",
    step1Title: "Crear Cuenta",
    step1Desc: "Regístrate y obtén recompensas de bienvenida exclusivas",
    step2Title: "Compra Rápida",
    step2Desc: "Compra cripto en pasos simples",
    step3Title: "Comienza a Operar",
    step3Desc: "Opera, copia trades y gana más",
    welcomeBonus: "Bono de Bienvenida",
    forNewUsers: "Para nuevos usuarios",
  },
  
  security: {
    title: "Protegemos Cada Operación",
    subtitle: "Seguridad multicapa para proteger tus activos",
    advancedSecurity: "Seguridad Avanzada",
    advancedSecurityDesc: "Contratos inteligentes auditados y monitoreo on-chain previenen vulnerabilidades",
    proofOfReserves: "Prueba de Reservas",
    proofOfReservesDesc: "Primera plataforma en proporcionar 100% de reservas con auditorías transparentes",
    secureStorage: "Almacenamiento Seguro",
    secureStorageDesc: "Almacenamiento estratégico en cold wallet para proteger tus activos",
  },
  
  cta: {
    title: "Comienza Tu Viaje Hoy",
    subtitle: "Únete a millones de traders en todo el mundo y disfruta de una experiencia de trading segura y confiable",
    createAccount: "Crear Cuenta Gratis",
    exploreMarkets: "Explorar Mercados",
  },
  
  footer: {
    products: "Productos",
    services: "Servicios",
    support: "Soporte",
    company: "Empresa",
    legal: "Legal",
    description: "Una plataforma de trading global de confianza para millones de usuarios. Opera de forma segura y transparente.",
    downloadApp: "Descargar App",
    sslEncrypted: "Encriptado SSL",
    reserves: "Reservas",
    securityAudited: "Auditoría de Seguridad",
    allRightsReserved: "Todos los derechos reservados",
    riskWarning: "Advertencia de Riesgo: El trading de criptomonedas implica alto riesgo. Asegúrate de entender los riesgos antes de operar.",
    termsOfService: "Términos de Servicio",
    privacyPolicy: "Política de Privacidad",
    riskDisclosure: "Divulgación de Riesgos",
    amlPolicy: "Política AML",
    helpCenter: "Centro de Ayuda",
    faq: "FAQ",
    fees: "Comisiones",
    apiDocs: "Docs API",
    submitRequest: "Enviar Solicitud",
    aboutGateGroup: "Sobre GateGroup",
    news: "Noticias",
    partnerships: "Alianzas",
    buyCrypto: "Comprar Cripto",
  },
  
  promo: {
    signUpNow: "Regístrate ahora y obtén hasta",
    upTo: "",
    inRewards: "en recompensas",
  },
  
  priceCard: {
    hot: "Caliente",
    new: "Nuevo",
    gainers: "Ganadores",
  },
  
  partners: {
    officialPartner: "Socio Oficial:",
  },
  
  loginPage: {
    title: "Iniciar Sesión",
    welcome: "Bienvenido de vuelta a GateGroup",
    email: "Correo Electrónico",
    password: "Contraseña",
    forgotPassword: "¿Olvidaste tu contraseña?",
    loggingIn: "Iniciando sesión...",
    continueWith: "O continúa con",
    noAccount: "¿No tienes cuenta?",
    registerNow: "Regístrate Ahora",
    demoAccount: "Cuenta demo:",
    invalidCredentials: "Correo o contraseña inválidos",
    twoFactorTitle: "Autenticación de Dos Factores",
    twoFactorDesc: "Ingresa el código de tu app de autenticación",
    verify: "Verificar",
    goBack: "Volver",
    invalidCode: "Código de verificación inválido",
  },
  
  registerPage: {
    title: "Crear Cuenta",
    subtitle: "Únete a GateGroup hoy",
    welcomeBonus: "Bono de Bienvenida $100",
    bonusDesc: "Regístrate ahora y reclama tu bono",
    firstName: "Nombre",
    lastName: "Apellido",
    confirmPassword: "Confirmar Contraseña",
    agreeToTerms: "Acepto los",
    termsOfService: "Términos de Servicio",
    and: "y",
    privacyPolicy: "Política de Privacidad",
    creatingAccount: "Creando Cuenta...",
    createAccount: "Crear Cuenta",
    registerWith: "O regístrate con",
    haveAccount: "¿Ya tienes cuenta?",
    mustAgree: "Debes aceptar los Términos de Servicio",
    passwordMismatch: "Las contraseñas no coinciden",
    passwordLength: "La contraseña debe tener al menos 6 caracteres",
    accountFailed: "Error al crear la cuenta",
  },
  
  marketsPage: {
    title: "Mercados",
    subtitle: "Sigue precios, capitalización y volúmenes de trading",
    totalMarketCap: "Capitalización Total",
    volume24h: "Volumen 24h",
    btcDominance: "Dominancia BTC",
    activeCryptos: "Criptos Activas",
    all: "Todo",
    hot: "Caliente",
    newListings: "Nuevos Listados",
    topGainers: "Mayores Ganancias",
    topLosers: "Mayores Pérdidas",
    searchCoins: "Buscar monedas...",
    filter: "Filtrar",
    name: "Nombre",
    price: "Precio",
    change24h: "Cambio 24h",
    volume: "Volumen 24h",
    action: "Acción",
    trade: "Operar",
    loadMore: "Cargar Más",
    readyToTrade: "¿Listo para Operar?",
    joinMillions: "Únete a millones de traders y comienza tu viaje cripto hoy",
  },
  
  learnPage: {
    title: "Aprende",
    titleHighlight: "Trading de",
    titleEnd: "Cripto",
    subtitle: "Cursos, tutoriales y guías gratuitas para dominar el trading de criptomonedas",
    searchPlaceholder: "Buscar cursos, artículos, videos...",
    all: "Todo",
    beginner: "Principiante",
    trading: "Trading",
    security: "Seguridad",
    defi: "DeFi",
    featuredCourses: "Cursos Destacados",
    viewAll: "Ver Todo",
    videoTutorials: "Video Tutoriales",
    articlesGuides: "Artículos y Guías",
    faq: "Preguntas Frecuentes",
    faqSubtitle: "Respuestas rápidas a preguntas comunes",
    viewAllFaqs: "Ver Todas las FAQs",
    readyToPractice: "¿Listo para Poner en Práctica lo Aprendido?",
    startTradingConfidence: "Comienza a operar con confianza usando lo que has aprendido",
    startTradingNow: "Comienza a Operar Ahora",
    lessons: "lecciones",
    views: "vistas",
    minRead: "min lectura",
  },
  
  companyPage: {
    title: "Sobre",
    titleHighlight: "GateGroup",
    subtitle: "Construyendo el futuro de las finanzas haciendo las criptomonedas accesibles, seguras y simples para todos.",
    registeredUsers: "Usuarios Registrados",
    countriesServed: "Países Servidos",
    dailyVolume: "Volumen Diario",
    cryptocurrencies: "Criptomonedas",
    ourStory: "Nuestra Historia",
    ourStoryP1: "Fundada en 2017, GateGroup comenzó con una misión simple: hacer el trading de criptomonedas accesible para todos.",
    ourStoryP2: "Lo que comenzó como un pequeño equipo de entusiastas cripto se ha convertido en una plataforma global que sirve a millones de usuarios.",
    ourStoryP3: "Hoy, nos enorgullece ser uno de los principales exchanges de criptomonedas del mundo.",
    ourValues: "Nuestros Valores",
    ourValuesSubtitle: "Los principios que guían todo lo que hacemos",
    securityFirst: "Seguridad Primero",
    securityFirstDesc: "Priorizamos la seguridad de los activos de nuestros usuarios.",
    userCentric: "Centrado en el Usuario",
    userCentricDesc: "Cada decisión se guía por lo mejor para nuestros usuarios.",
    innovation: "Innovación",
    innovationDesc: "Empujamos constantemente los límites para proporcionar soluciones de vanguardia.",
    globalAccess: "Acceso Global",
    globalAccessDesc: "Haciendo las criptomonedas accesibles para todos, en todas partes.",
    securityTrust: "Seguridad y Confianza",
    securityTrustSubtitle: "Tu seguridad es nuestra máxima prioridad",
    proofOfReserves: "Prueba de Reservas",
    proofOfReservesDesc: "100% de los activos de usuarios respaldados y verificables on-chain.",
    coldStorage: "Cold Storage",
    coldStorageDesc: "La mayoría de activos almacenados en cold wallets seguros.",
    regularAudits: "Auditorías Regulares",
    regularAuditsDesc: "Auditorías de terceros aseguran los más altos estándares.",
    insuranceFund: "Fondo de Seguro",
    insuranceFundDesc: "Un fondo dedicado para proteger a los usuarios.",
    leadershipTeam: "Equipo de Liderazgo",
    leadershipSubtitle: "Conoce a las personas que impulsan nuestra misión",
    globalPresence: "Presencia Global",
    globalPresenceSubtitle: "Sirviendo usuarios en todo el mundo con soporte regional",
    joinOurTeam: "Únete a Nuestro Equipo",
    joinTeamDesc: "Siempre buscamos individuos talentosos que compartan nuestra pasión por las criptomonedas.",
    viewOpenPositions: "Ver Posiciones Abiertas",
    teamMembers: "Miembros del Equipo",
    countries: "Países",
    openRoles: "Roles Abiertos",
    remoteFriendly: "Remoto Amigable",
    getInTouch: "Contáctanos",
    getInTouchSubtitle: "¿Tienes preguntas? Estamos aquí para ayudar",
    emailUs: "Escríbenos",
  },
  
  chat: {
    title: "Asistente GateGroup",
    online: "En línea",
    welcomeMessage: "¡Hola! 👋 Soy tu asistente de IA de GateGroup.\n\n¿Cómo puedo ayudarte hoy?",
    placeholder: "Escribe tu mensaje...",
    poweredBy: "Impulsado por IA",
    instantSupport: "Soporte Instantáneo 24/7",
    newChat: "Nuevo chat",
    errorMessage: "Lo siento, ocurrió un error. Por favor intenta de nuevo.",
    connectionError: "Lo siento, error de conexión. Por favor intenta más tarde.",
    quickQuestion1: "¿Cómo empiezo a operar?",
    quickQuestion2: "¿Cuáles son las comisiones?",
    quickQuestion3: "¿Cómo deposito?",
    quickQuestion4: "¿Es segura la plataforma?",
  },
  
  languages: {
    ar: "العربية",
    en: "English",
    es: "Español",
    de: "Deutsch",
    zh: "中文",
    ja: "日本語",
    he: "עברית",
  },
};

export default es;
